import React from 'react';

function SupervisorIcon({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99167 6.66667C9.99167 8.05 8.88333 9.16667 7.5 9.16667C6.11667 9.16667 5 8.05 5 6.66667C5 5.28334 6.11667 4.16667 7.5 4.16667C8.88333 4.16667 9.99167 5.28334 9.99167 6.66667ZM15.825 7.91667C15.825 9.06667 14.9 10 13.75 10C12.6 10 11.6667 9.06667 11.6667 7.91667C11.6667 6.76667 12.6 5.83334 13.75 5.83334C14.9 5.83334 15.825 6.76667 15.825 7.91667ZM13.75 11.6667C12.225 11.6667 9.16667 12.4333 9.16667 13.9583V15C9.16667 15.4583 9.54167 15.8333 10 15.8333H17.5C17.9583 15.8333 18.3333 15.4583 18.3333 15V13.9583C18.3333 12.4333 15.275 11.6667 13.75 11.6667ZM1.66667 13.75C1.66667 11.8083 5.55833 10.8333 7.5 10.8333C8.05 10.8333 8.75 10.9167 9.475 11.0667C7.775 12.0083 7.5 13.25 7.5 13.9583V15.8333H2.5C2.04167 15.8333 1.66667 15.4583 1.66667 15V13.75Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SupervisorIcon;
